export const RouteGetStoresCategoriesList = "/stores/categories/list";

export interface ParamsGetStoresCategoriesList {
  storeId: string;
}

export type ResponseGetStoresCategoriesList = {
  id: number;
  code: string;
}[];
